export default __webpack_public_path__ + "static/media/Pitch.5cc200d1.svg";